<template>
    <div class="login-page flex">
        <div class="box grow scrollable align-vertical side-box box-left">
            <div class="align-vertical-middle wrapper text-center">
                <img class="image-logo" src="../../../assets/images/logoBlue.png" alt="logo-left"/>
                <h1 class="h-big">{{$t('src.firma')}}</h1>
                <p class="p-50">{{$t('src.aciklama')}}</p>
            </div>
        </div>
        <div class="box grow scrollable align-vertical side-box box-right">
            <div class="align-vertical-middle wrapper">

                <form class="form-box" @submit.prevent="login">
                    <img class="image-logo" src="../../../assets/images/avatar.jpg"
                         style=" border-radius: 50%; margin-bottom: 20px;width: 120px" alt="logo-left"/>
                    <float-label class="styled animated fadeInRight">
                        <input type="username" name="username"
                               :placeholder="$t('src.views.authentication.login.kullaniciAdi')" v-model="username">
                    </float-label>
                    <float-label v-if="!sifreUnuttum" class="styled animated fadeInRight">
                        <input type="password" name="password" :placeholder="$t('src.views.authentication.login.sifre')"
                               v-model="password">
                    </float-label>
                    <div v-if="!sifreUnuttum" class="flex">
                        <div class="box grow text-right animated fadeInRight">
                            <el-button type="text" v-on:click="sifreUnuttum = true">
                                {{$t('src.views.authentication.login.sifremiUnuttum')}}
                            </el-button>
                        </div>
                    </div>
                    <div class="flex text-center center pt-30 pb-10">
                        <el-button v-if="!sifreUnuttum" plain size="small" native-type="submit"
                                   class="login-btn pulse animated themed animated fadeInRight">
                            {{$t('src.views.authentication.login.login')}}
                        </el-button>
                        <el-button v-if="sifreUnuttum" plain size="small" @click="sifremiUnuttum"
                                   class="login-btn pulse animated themed animated fadeInRight">
                            {{$t('src.views.authentication.login.sifreYenile')}}
                        </el-button>
                    </div>
                    <div style="margin-top: 10px">
                        <el-button
                                v-if="sifreUnuttum" v-on:click="sifreUnuttum=false"
                                class="buttonPage left animated fadeInRight delay-1s"
                                style="float: left; cursor: pointer" icon="mdi mdi-chevron-double-left" type="text"
                                size="small">
                        </el-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import yonetimService from '../../../WSProvider/YoneticiService'
    import status from '../../../status'

    import i18n from '../../../i18n'

    let base64 = require('base64_js');
    export default {
        name: 'Login',
        data() {
            return {
                sifreUnuttum: false,
                username: '',
                password: ''
            }
        },
        methods: {
            login() {
                let self = this;
                yonetimService.girisYap(this.username, this.password).then((response) => {
                    if(response.status === 200){
                        console.log(response)
                        if (response.data && response.data.yonetimId) {
                            var userDataArtdoor = base64.encode(encodeURI(JSON.stringify(response.data)))
                            localStorage.setItem("userDataArtdoor", userDataArtdoor);
                            self.$store.commit('setLogin');
                            self.$router.push('dashboard');
                        }
                        document.body.style.zoom = "80%";
                    }else{
                       status.Status(response.status,this)
                    }
                });
            },
            sifremiUnuttum() {
                yonetimService.sifremiUnuttum(this.username).then((response) => {
                    if(response.status === 200){
                        status.Status('success', this, 'Yeni Şifreniz E-Posta Adresinize gönderilmiştir.');
                    }else{
                        status.Status(response.status,this)
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables';

    .buttonPage {
        font-size: 30px;
        border: none;
        color: #9a9a9a;
        position: relative;
        transition: all 0.5s;
    }

    .login-page {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 !important;

        .side-box {
            .wrapper {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
            }
        }

        .box-left {
            background-image: url('../../../assets/images/login2.jpg');
            background-size: cover;
            background-position: 50% 50%;

            .wrapper {
                .image-logo {
                    width: 90%;
                    max-width: 100px;
                    margin-top: 20px;
                }

            }
        }

        .box-right {
            background: white;
            color: var(--background-color);
        }

        .form-box {
            width: 100%;
            max-width: 340px;
            padding: 30px;
            box-sizing: border-box;
            margin: 20px auto;
            //background: transparent;

            a {
                font-size: 14px;
                color: var(--color-accent);
                text-decoration: none;
                font-weight: 500;
            }

            .image-logo {
                width: 80px;
                margin: 0px auto;
                margin-bottom: 70px;
                display: block;
            }

            .login-btn {
                background: rgba(var(--color-accent-rgb), .2);
                color: var(--text-color);
                border-color: var(--text-color);
                border-width: 2px;
                font-weight: bold;
                border-radius: 0;

                &:hover {
                    background: rgba(var(--color-accent-rgb), 1);
                    border-color: var(--text-color);
                    color: var(--text-color);
                }
            }
        }
    }

    @media (max-width: 1200px) {
        .login-page {
            .box-left {
                .wrapper {
                    .h-big {
                        font-size: 50px;
                    }
                }
            }
        }
    }

    @media (max-width: 900px) {
        .login-page {
            .box-left {
                .wrapper {
                    .h-big {
                        font-size: 30px;
                    }
                }
            }
        }
    }

    @media (max-width: 768px) {
        .login-page {
            display: block;
            overflow: auto;

            .side-box {
                display: block;
            }
        }
    }
</style>
